import { render } from "./terms2.vue?vue&type=template&id=efb2ba1e&scoped=true"
const script = {}

import "./terms2.vue?vue&type=style&index=0&id=efb2ba1e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/ws-frontend-join/ws-frontend-join/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efb2ba1e"]])

export default __exports__